module.exports = __webpack_public_path__ + "static/media/driver.0f6493e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/driver.svg
// module id = 1146
// module chunks = 0